import Storage from 'react-native-storage';

const _appStateId = 'appState';
const _appStateCacheKey = 'appState';

export class AppStateProvider
{
    constructor(allowStorageAccess)
    {
        if (!window.storage && allowStorageAccess)
        {
            window.storage  = new Storage({
                // maximum capacity, default 1000
                size: 1000,

                // Use AsyncStorage for RN, or window.localStorage for web. If not set, data would be lost after reload.
                storageBackend: window.localStorage,

                // expire time, default 30 minutes
                defaultExpires: 1000 * 900,

                // cache data in the memory. default is true.
                enableCache: true
            });
        }
    }

    async getAppState()
    {
        return await window.storage.getItem(_appStateCacheKey);
    }

    async setAppState(appState, allowStorageAccess)
    {
        if (allowStorageAccess) {
            await window.storage.save({
                key: _appStateCacheKey,
                id: _appStateId,
                data: appState,
                expires: null // Never expire
            });
        }

        return appState;
    }
}
